var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0142 10.4529L16 10.9691L14.9858 10.4529C13.0562 9.49127 10.9301 8.98956 8.77419 8.98712H8V20.8581H8.77419C10.6891 20.8565 12.5784 21.2981 14.2942 22.1484L16 23.0129L17.7058 22.1484C19.4216 21.2981 21.3109 20.8565 23.2258 20.8581H24V8.98712H23.2258C21.0699 8.98956 18.9438 9.49127 17.0142 10.4529ZM9.54839 19.3303V10.5562C11.2005 10.6655 12.8141 11.1042 14.2942 11.8465L15.2258 12.3033V20.8968L14.9858 20.7781C13.2903 19.9318 11.4403 19.4392 9.54839 19.3303ZM22.4516 19.3303C20.5599 19.4384 18.7099 19.9301 17.0142 20.7755L16.7742 20.8942V12.3033L17.7058 11.8258C19.1878 11.0925 20.8013 10.6626 22.4516 10.5613V19.3303Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/Read.e90e5b075d6bede8e4b71b2a57349001.svg";
export { ForwardRef as ReactComponent };